/**
 * App dialog bridge for non-React code (e.g. lib helpers).
 * Falls back to browser dialogs if provider is not mounted.
 */

let bridge = null;

export function registerAppDialog(api) {
  bridge = api;
}

export function appAlert(message, title = "Notice") {
  if (bridge?.alert) {
    return bridge.alert(message, title);
  }
  window.alert(message);
  return Promise.resolve();
}

export function appConfirm(message, title = "Confirm", options = {}) {
  if (bridge?.confirm) {
    return bridge.confirm(message, title, options);
  }
  return Promise.resolve(window.confirm(message));
}
